import { FETCH_TOURNAMENTS, FETCH_TOURNAMENTS_SUCCESS, FETCH_TOURNAMENTS_FAIL, NEW_MATCH_UPDATE } from "../actions/types";

const initialState = {
    results: null,
    isLoading: false,
    isError: false,
};

export default function store(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case FETCH_TOURNAMENTS:
            return {
                ...state,
                isLoading: true,
            };
        case FETCH_TOURNAMENTS_SUCCESS:
            return {
                ...state,
                results: payload,
                isLoading: false,
                isError: false,
            };
        case FETCH_TOURNAMENTS_FAIL:
            return {
                ...state,
                results: null,
                isLoading: false,
                isError: true,
            };
        default:
            return state;
    }
}